import React, { ReactNode } from "react";
interface Props {
  headline: string;
  body: string;
  children: ReactNode;
}
const ContentCustomCalculator = ({
  headline,
  body,
  children
}: Props) => {
  if (!children) {
    return null;
  }
  return <div className="border-gray-200  border-solid border-r-0 border-b-0 border-l-0 border-t pt-6" data-testid="content-custom-calculator" data-sentry-component="ContentCustomCalculator" data-sentry-source-file="ContentCustomCalculator.tsx">
      <div className="flex flex-row items-start overflow-hidden xs:items-center w-full">
        <div className="py-0 px-8 text-center w-full xs:py-8">
          <h3 className="item-header font-semibold text-lg leading-4 mb-1 xs:text-3xl"
        // TODO: remove dangerouslySetInnerHTML
        dangerouslySetInnerHTML={{
          __html: headline
        }} />
          {/* TODO: remove dangerouslySetInnerHTML */}
          {}
          <p dangerouslySetInnerHTML={{
          __html: body
        }} />
          <p className="muted small text-xs mb-0 -mt-3">
            *Calculations are an estimate and actual results may vary
          </p>
        </div>
      </div>
      {children}
    </div>;
};
export default ContentCustomCalculator;